export const clearAllAlerts = () => {
  const emailElement = document.querySelector('#email');
  const emailInputErrorElement = document.querySelector('.error-email');
  const formErrorElement = document.querySelector('.error-box-form');
  emailElement.classList.remove('is-invalid');
  emailInputErrorElement.classList.add('hidden');
  formErrorElement.classList.add('hidden');
}
